import { createRouter, createWebHistory } from 'vue-router'
import Payment from '../views/payment/index.vue'
import PayCallback from '../views/paycallback/index.vue'
import Jumping from '../views/jumping/index.vue'
import NotFound from '../views/NotFound.vue'
import AccumRecharge from '../views/act/accumRecharge/index.vue'
import Accum from '../views/act/accum/index.vue'
import WC2026 from '../views/act/wc2026/index.vue'
// import MWR2025 from '../views/act/mwr2025/index.vue'
// import MWR2025Home from '../views/act/mwr2025/home/index.vue'
// import MWR2025Stats from '../views/act/mwr2025/stats/index.vue'
// import MWR2025Dragon from '../views/act/mwr2025/dragon/index.vue'
// import CNY from '../views/act/cny/index.vue'
// import SF from '../views/act/sf/index.vue'
// import SFTest from '../views/act/sf/test.vue'

// 允许自动跳转的路径列表（无locale参数时，会根据IP自动跳转到对应区域）
// 这些路径会在路由守卫中自动添加locale前缀
export const allowedAutoRedirectPaths = ['/', '/cny', '/accum', '/sf', '/mwr2025/home', '/mwr2025/stats', '/mwr2025/dragon', '/wc2026']

const routes = [
  {
    path: '/:locale',
    children: [
      {
        path: '',
        name: 'Payment',
        component: Payment
      },
      {
        path: 'accumRecharge',
        name: 'AccumRecharge',
        component: AccumRecharge
      },
      {
        path: 'accum',
        name: 'Accum',
        component: Accum
      },
      {
        path: 'wc2026/home',
        name: 'WC2026',
        component: WC2026
      },
      // {
      //   path: 'cny',
      //   name: 'CNY',
      //   component: CNY
      // },
      // {
      //   path: 'sf',
      //   name: 'SF',
      //   component: SF
      // },
      // {
      //   path: 'sf/test',
      //   name: 'SFTest',
      //   component: SFTest
      // },
      // {
      //   path: 'mwr2025',
      //   name: 'MWR2025',
      //   component: MWR2025,
      //   redirect: 'home',
      //   children: [
      //     {
      //       path: 'home',
      //       name: 'MWR2025Home',
      //       component: MWR2025Home
      //     },
      //     {
      //       path: 'stats',
      //       name: 'MWR2025Stats',
      //       component: MWR2025Stats
      //     },
      //     {
      //       path: 'dragon',
      //       name: 'MWR2025Dragon',
      //       component: MWR2025Dragon
      //     }
      //   ]
      // },
      {
        path: 'callback/:channel', // channel对应的是每个支付平台
        name: 'callback',
        component: PayCallback
      },
      {
        path: 'jumping',
        name: 'Jumping',
        component: Jumping
      }
    ]
  },
  {
    path: '/404',
    name: 'NotFound',
    component: NotFound
  }
]
console.log(process.env.VUE_APP_HISTORY_URL, 'process.env.VUE_APP_HISTORY_URL')
const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_HISTORY_URL),
  routes
})

export default router
